"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.numberTrackedLinkTargets = exports.normalizeTrackedLinkTarget = exports.toFormLinkTarget = void 0;
const emails_1 = require("../constants/emails");
const string_1 = require("./string");
const UNLAYER_FORM_LINK_BUTTON_PATTERN = /^{{unlayer-form-link-button-(?:DonationForm|Ticketing)-([a-zA-Z0-9-]+?)(?:\?[^}]*)?}}$/;
const toFormLinkTarget = (formId) => `form:${formId}`;
exports.toFormLinkTarget = toFormLinkTarget;
const normalizeTrackedLinkTarget = (href) => {
    const decodedHref = (0, string_1.decodeHtmlEntities)(href).trim();
    const formButton = decodedHref.match(UNLAYER_FORM_LINK_BUTTON_PATTERN);
    if (formButton) {
        return (0, exports.toFormLinkTarget)(formButton[1]);
    }
    if (!URL.canParse(decodedHref)) {
        return decodedHref;
    }
    const url = new URL(decodedHref);
    url.searchParams.delete(emails_1.EMAIL_DELIVERY_LINK_ID_KEY);
    url.searchParams.sort();
    return url.toString();
};
exports.normalizeTrackedLinkTarget = normalizeTrackedLinkTarget;
const numberTrackedLinkTargets = (links) => {
    const seenCountByTarget = new Map();
    return links.map((link) => {
        const occurrence = seenCountByTarget.get(link.target) ?? 0;
        seenCountByTarget.set(link.target, occurrence + 1);
        return { ...link, occurrence };
    });
};
exports.numberTrackedLinkTargets = numberTrackedLinkTargets;
